import { jsx as r } from "react/jsx-runtime";
import { getTimeAgoString as i } from "../../../../services/time/index.js";
import { Timestamp as n } from "./style.js";
import { useTranslationContext as a } from "../../../../contexts/TranslationProvider/context.js";
function T({
  timestamp: t,
  ...o
}) {
  const { locale: m } = a(), e = i(
    new Date(t || ""),
    m || ""
  );
  return /* @__PURE__ */ r(n, { ...o, children: e });
}
export {
  T as CommentTimestamp
};
